import FormsModule from './editor/module';

const Cool_FormKitForms = new FormsModule();

window.Cool_FormKitForms = Cool_FormKitForms;
